<template>
  <div class="painel p-0">
    <div class=" container">
      <div class="row">
        <!-- <div class="col-sm-6 col-lg-3 my-3 px-4 text-center bloco_icon" v-for="list in listagem" :key="list.id">
          <router-link :to="link_montado" class="btn btn-light d-block d-sm-block bloco_link" :title="titulo">
            <p>
              <img src="/img/logo.png" alt="Titulo" class="img-fluid img-thumbnail rounded mx-auto d-block" />
            </p>
            <p class="titulo">
              {{ list.titulo }}
              <span class="d-flex col-10 offset-1"></span>
            </p>
            <small class="short_descr"> descrição curta </small> {{ list.link_amistoso }}
          </router-link>
        </div> -->

        <BlocoNoticiasDestaque id="noticias_home_destaque" v-for="list in listagem_destaque" :key="list.id" :descricao="list.breve_descricao"
          :link="list.link_amistoso" :categoria="list.categoria" :img_noticia="list.imagem" :titulo="list.titulo" :sub_titulo="list.sub_titulo"
          :redator="list.redator" :ativa_placeholder="ativa_placeholder" />
        <hr>
        <BlocoNoticias id="noticias_home" v-for="list in listagem" :key="list.id" :descricao="list.breve_descricao"
          :link="list.link_amistoso" :categoria="list.categoria" :img_noticia="list.imagem" :titulo="list.titulo" :sub_titulo="list.sub_titulo"
          :ativa_placeholder="ativa_placeholder" />

        <p class="text-end border-top" id="vermais">
          <router-link class="btn btn-sm btn-dark" to="/noticias">Ver mais</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { filtro_loading } from '@/assets/js/functions';
import BlocoNoticias from './BlocoNoticias.vue';
import BlocoNoticiasDestaque from './BlocoNoticiasDestaque.vue';
import { api } from '@/services/api';

export default {
  name: "PainelNoticias",
  props: {
  },
  components: {
    BlocoNoticias,
    BlocoNoticiasDestaque
  },
  data() {
    return {
      listagem: {
        id: 0,
        titulo: '',
        img_noticia: '',
        categoria: '',
        descricao: '',
        link_amistoso: '',
      },
      listagem_destaque: {
        id: 0,
        titulo: '',
        img_noticia: '',
        categoria: '',
        descricao: '',
        link_amistoso: '',
      },
      ativa_placeholder: true,
    }
  },
  methods: {
    async lista_noticias() {
      this.listagem_destaque = await api.post('news/list_site_emphasis/3/1')
      this.listagem = await api.post('news/list_site_home/6/1/0/0/3')
      this.ativa_placeholder = false
    },
  },
  computed: {
    link_montado: function () {
      return '/noticias/lnk/' + this.listagem.link_amistoso
    },
  },
  mounted() {
    this.lista_noticias()
  },
};
</script>

<style scoped>
p {
  display: block;
  text-align: center;
}

#vermais {
  margin-top: 20px;;
}

.painel {
  border-top: 3px 0 3px solid var(--cor-base-texto);
}

.bloco_icon {
  font-size: 1.3rem;
}

.bloco_icon span {
  border-bottom: 1px solid var(--cor-base-texto);
}

.icone_eleitor {
  color: white;
  background-color: var(--cor-base-texto);
  border: var(--cor-base-texto) 2px solid;
  font-size: 50px;
}

.titulo {
  font-size: 1.2rem;
}

.short_descr {
  font-size: 11px;
}
</style>